import React, { Component, Fragment } from 'react';
import { Icons, Link, NoWrap } from 'components';
import css from './footer.scss';

export function Footer(props) {
  return (
    <footer className={css.footer}>
      <div className={css.container}>
        <ul className={css.menu}>
          <li><Link to="/privacy/">Privacy Policy</Link></li>
          <li><Link to="/terms/">Terms</Link></li>
          <li><Link to="/faq/">FAQ</Link></li>
          <li><Link to="/contact/">Contact</Link></li>
        </ul>
        <ul className={css.social}>
          <li><a target="_blank" href="https://www.facebook.com/SuccessWizard"><Icons.Facebook /></a></li>
          <li><a target="_blank" href="https://www.linkedin.com/company/success-wizard"><Icons.Linkedin /></a></li>
          <li><a target="_blank" href="https://www.youtube.com/watch?v=kJpahdQRALI&feature=youtu.be"><Icons.Youtube /></a></li>
          <li><a target="_blank" href="https://twitter.com/Success_Wizard"><Icons.Twitter /></a></li>
        </ul>
        <p className={css.copyrights}>
          <NoWrap>© { new Date().getFullYear() } Success Wizard, Inc.</NoWrap> {' '}
          <NoWrap>All Rights Reserved</NoWrap>
        </p>
      </div>
    </footer>
  );
}
